import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-toastify";
import { auth } from "../../../../../firebase.init";

const AddProduct = () => {
  const [validated, setValidated] = useState(false);
  const [user] = useAuthState(auth);
  const toastId = React.useRef(null);

  const notify = () =>
    (toastId.current = toast("Uploading", { autoClose: false }));

  const update = () =>
    toast.update(toastId.current, {
      render: "Successfully Added",
      type: toast.TYPE.SUCCESS,
      autoClose: 3000,
    });

  const url = `https://rocky-ravine-79485.herokuapp.com/add-product`;

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      const productName = event.target.productName.value;
      const productPrice = event.target.productPrice.value;
      const productQuantity = event.target.productQuantity.value;
      const photoURL = event.target.photoURL.value;
      const productCategory = event.target.productCategory.value;
      const productDescription = event.target.productDescription.value;
      const email = user.email;
      const newProductInfo = {
        email,
        productName,
        productCategory,
        productPrice,
        photoURL,
        productQuantity,
        productDescription,
      };
      // console.log(newProductInfo);

      axios.post(url, newProductInfo).then((res) => {
        const resSuccess = res.status;
        notify();
        if (resSuccess === 200) {
          const form = document.getElementById("addProduct");
          update();
          form.reset();
        }
      });
    }

    setValidated(true);
  };
  const [shwoImgurl,setShwoImgUrl]=useState("")
  const handleVisualImg = (event) => {
    setShwoImgUrl(event.target.value)
    document.getElementById("product-img").style.visibility="visible"
  };
  return (
    <>
      <Container>
        <Row>
          {/* <MyEditor></MyEditor> */}
          <Col md={12}>
            <h1 className="text-center my-4">Add New Products</h1>
            <hr />
            <br />
            <Form
              id="addProduct"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <Row className="mb-3">
                <Form.Group
                  as={Col}
                  className="my-3"
                  md="10"
                  controlid="validationCustom01"
                >
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    name="productName"
                    required
                    type="text"
                    placeholder="Product Name"
                    defaultValue=""
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlid="validationCustom02">
                  <Form.Label>Price</Form.Label>{" "}
                  <InputGroup
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlid="price"
                  >
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control required type="number" name="productPrice" />
                  </InputGroup>
                </Form.Group>
                <Form.Group as={Col} md="4" controlid="validationCustom02">
                  <Form.Label>Quantity</Form.Label>{" "}
                  <InputGroup
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlid="price"
                  >
                    <Form.Control
                      name="productQuantity"
                      required
                      type="number"
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="10"
                  controlid="validationCustomUsername"
                >
                  <Form.Label>Photo URL</Form.Label>
                  <InputGroup hasValidation>
                    <InputGroup.Text id="inputGroupPrepend">
                      <svg
                        width={15}
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                        />
                      </svg>
                    </InputGroup.Text>
                    <Form.Control
                      onChange={handleVisualImg}
                      type="url"
                      name="photoURL"
                      placeholder="Please Input A Valid Image URL"
                      aria-describedby="inputGroupPrepend"
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Please input a valid URL.
                    </Form.Control.Feedback>
                  </InputGroup>
                  <img id="product-img" style={{height:'150px', borderRadius:'10px', width:'200px',objectFit:'contain' ,visibility:'hidden'}} className="bordered shadow mt-3 " src={shwoImgurl} alt="Invalid URL" />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlid="validationSelect">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    aria-label="Select A Category"
                    name="productCategory"
                    defaultValue="1"
                  >
                    <option value={1} disabled>
                      Select A Category
                    </option>
                    <option value="fruit">Fruit</option>
                    <option value="dairy">Dairy</option>
                    <option value="Fish">Meet</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <Row>
                <Col md={8} className="mb-4">
                  <Form.Group
                    // className="mb-3"
                    controlid="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      name="productDescription"
                      as="textarea"
                      rows={4}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button type="submit">Submit form</Button>
            </Form>
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddProduct;
